import { Address } from '@/modules/rmp/pages/services/MissingPerson';

import { SERVICE_CODES } from '@/lib/consts';

import { client } from '../../core/client';

import type {
  DocumentType,
  DataResponse,
  ResponseReapplicationOrders,
  ResponseUserWeaponTechnicalConditionDocument,
  GetWeaponTechnicalConditionDocumentParams,
  RedeliveryStatusResponse,
} from '../../types';
import type { AddressCheckResult, IntegrationSystem, ServiceCode } from '@/shared/types';

export const erz = {
  services: {
    getWeaponTechnicalConditionDocument: (
      queryParams: GetWeaponTechnicalConditionDocumentParams,
    ): Promise<DataResponse<ResponseUserWeaponTechnicalConditionDocument>> => {
      return client.get(`/weapons/inspection?${new URLSearchParams(queryParams).toString()}`);
    },
    getReapplicationOrders: (): Promise<DataResponse<ResponseReapplicationOrders[]>> => {
      return client.get(`/user-requests/${SERVICE_CODES.REAPPLICATION}/orders`);
    },
    canReapplicationSubmit: (subject_id: string): Promise<DataResponse<Record<'canSubmit', boolean>>> => {
      return client.get(`/user-requests/${SERVICE_CODES.REAPPLICATION}/canSubmit?subject_id=${subject_id}`);
    },
    checkRedeliveryState: (requestId: string): Promise<DataResponse<RedeliveryStatusResponse>> => {
      return client.post(`/user-requests/${SERVICE_CODES.EXTRACT_REDELIVERY}/checkState`, { requestId });
    },
    checkReapplicationState: (requestId: string): Promise<DataResponse<{ status: 'NEW' | 'DRAFT' }>> => {
      return client.get(`/user-requests/${SERVICE_CODES.REAPPLICATION}/checkState?subject_id=${requestId}`);
    },
    checkPurchasePermit: (
      object_id: string,
      object_name: string,
    ): Promise<DataResponse<{ has_valid_permit: boolean }>> => {
      return client.post(`/user-requests/${SERVICE_CODES.PURCHASE}/verify/permit`, {
        purchase: { object_id, object_name },
      });
    },
    checkAddressEquality: (
      serviceCode: ServiceCode,
      declared_address: Address,
      registered_address: Address,
    ): Promise<
      DataResponse<{ status: AddressCheckResult; is_allowed: boolean; verified_addresses: Nullable<string[]> }>
    > => {
      return client.post(`/user-requests/${serviceCode}/verify/address`, { declared_address, registered_address });
    },
  },
  dictionary: {
    getDocumentTypes: (): Promise<DataResponse<Array<DocumentType<IntegrationSystem.ERZ>>>> => {
      return client.get(`/referenceBook/dictionary?name=document-types`);
    },
  },
};
